const bg = {
  lighting: {
    align: 'left',
    mask: {
      radius: 0.6,
      blur: 0,
      x: 0.95,
      y: .5,
      alpha: 1.0,
    },
    halo: {
      radius: 0.45,
      blur: 0,
      x: 0.95,
      y: 0.05,
      alpha: 1.0,
    },
  },
  smoke: {
    align: 'right',
    mask: {
      radius: 0.6,
      blur: 0,
      x: 0,
      y: 0.5,
      alpha: 1.0,
    },
    halo: {
      radius: 0.45,
      blur: 0,
      x: 0,
      y: 0.95,
      alpha: 1.0,
    },
  },
  deleting: {
    align: 'left',
    mask: {
      radius: 0.6,
      blur: 0,
      x: 0,
      y: 0.7,
      alpha: 1.0,
    },
    halo: {
      radius: 0.45,
      blur: 0,
      x: 0,
      y: 0.07,
      alpha: 1.0,
    },
  },
  rubaway: {
    align: 'left',
    mask: {
      radius: 0.6,
      blur: 0,
      x: 0.9,
      y: 0.5,
      alpha: 1.0,
    },
    halo: {
      radius: 0.45,
      blur: 0,
      x: 0.96,
      y: 0.9,
      alpha: 1.0,
    },
  },
}

export default bg;



// WEBPACK FOOTER //
// ./app/frontend/components/animations/background/config.js